export default __webpack_public_path__ + "static/media/facility3.e35285b5.jpg";